
document.addEventListener("DOMContentLoaded", () => {
	const infoIcons = document.querySelectorAll(".info-icon");
	const closeBtns = document.querySelectorAll(".tooltip .close");

	infoIcons.forEach((icon) => {
		icon.addEventListener("click", (e) => {
			infoIcons.forEach((el) => el.classList.remove("show"));
			e.stopPropagation();
			icon.classList.toggle("show");
			console.log('click tooltip')
		});
	});

	closeBtns.forEach((btn) => {
		btn.addEventListener("click", (e) => {
			infoIcons.forEach((el) => el.classList.remove("show"));
			console.log('click close')
			
		});
	});

}); 